document.addEventListener('DOMContentLoaded', function() {
    // 初期化関数
    function initCart() {
        console.log('カートの初期化が実行されました');
        
        // .custom-cart-item要素を全て取得
        const cartItems = document.querySelectorAll('.custom-cart-item');
        cartItems.forEach(cartItem => {
            const finishDateCart = cartItem.getAttribute('data-finishdatecart');
            if (finishDateCart) {
                const finishDate = new Date(finishDateCart);
                checkAndApplyCartClass(cartItem, finishDate);
            }
        });
    }

    // 現在時刻を取得して比較する関数
    function checkAndApplyCartClass(cartItem, finishDate) {
        const currentDate = new Date();

        // フォーマットを揃える（ISO 8601形式）
        const formattedCurrentDate = currentDate.toISOString();
        const formattedFinishDate = finishDate.toISOString();

        // コンソールに出力
        console.log('現在時刻:', formattedCurrentDate);
        console.log('メタフィールドの時刻:', formattedFinishDate);

        // 現在時刻がメタフィールドの日付を超えているかどうかを確認
        if (currentDate > finishDate) {
            cartItem.classList.add('custom-cart-finish');
            console.log('custom-cart-finishクラスが追加されました:', cartItem);

            // .cart-btn-containerにdisable-checkoutクラスを追加
            const cartBtnContainer = document.querySelector('.cart-btn-container');
            if (cartBtnContainer) {
                cartBtnContainer.classList.add('disable-checkout');
                console.log('.cart-btn-containerにdisable-checkoutクラスが追加されました');
            }

            // .custom-cart-finish-textにdisplay-contentクラスを追加
            const customCartFinishText = document.querySelector('.custom-cart-finish-text');
            if (customCartFinishText) {
                customCartFinishText.classList.add('display-content');
                console.log('.custom-cart-finish-textにdisplay-contentクラスが追加されました');
            }
        }
    }

    // MutationObserverの設定
    const targetNode = document.querySelector('.yv_side_drawer_wrapper');
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                console.log('変化が検出されました:', mutation);
                initCart();
                break;
            }
        }
    };

    const observer = new MutationObserver(callback);

    if (targetNode) {
        observer.observe(targetNode, config);
        console.log('.yv_side_drawer_wrapperの監視を開始しました');
    } else {
        console.log('.yv_side_drawer_wrapperが見つかりません');
    }

    // 最初の読み込み時に1回実行
    initCart();
});
